import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';

export interface FontDetails {
  name: string;
  displayName: string;
  displayNameKey: string;
  path: string;
  fontFamily: string;
}

interface FontJson {
  filename: string;
  displayName: string;
  description: string;
}

interface FontCategory {
  name: string;
  nameKey: string;
  fonts: FontDetails[];
}

@Injectable({
  providedIn: 'root'
})
export class FontService {
  constructor(private http: HttpClient) {}

  getFontList(): Observable<FontDetails[]> {
    return this.http.get<FontJson[]>('assets/font/fonts.json').pipe(
      map(fonts => fonts.map(font => ({
        name: font.filename.replace('.TTF', ''),
        displayName: font.displayName,
        displayNameKey: `FONT.${font.displayName}`,
        path: `assets/font/${font.filename}`,
        fontFamily: font.filename.replace('.TTF', '')
      })))
    );
  }
} 